module.exports = __webpack_public_path__ + "static/media/InterpretingSpreadsSingleCard.59ecf50e.jpg";